



























import Vue from 'vue';
import { defineComponent, ref, watch, Ref, onMounted, computed } from '@vue/composition-api';

import mobiscroll from '../../mobiscroll/js/numpad.javascript';

const componentName = 'wok-mobile-picker-pin';

export default defineComponent({
    name: componentName,

    props: {
        template: {
            type: String,
            default: 'dddd'
        },
        placeholder: {
            type: String,
            default: '-'
        },
        pickerLabel: {
            type: String,
            default: ''
        },
        cancelLabel: {
            type: String,
            default: 'Cancel'
        },
        confirmLabel: {
            type: String,
            default: 'Confirm'
        }
    },

    setup(props, context) {
        const numpad = ref() as Ref<HTMLDivElement>;

        function formatValue(value: number | null) {
            if (value) {
                return value.toFixed();
            }
            return '0';
        }

        const lastSelectedValue = ref('');
        const confirmEnabled = computed(() => lastSelectedValue.value != '');

        const requiredDigits = props.template.split('').filter(x => x == 'd').length;

        let numpadInstance: any = null;

        onMounted(() => {
            numpadInstance = (<any>mobiscroll).numpad(numpad.value, {
                display: 'inline',
                showLabel: false,

                template: props.template,
                allowLeadingZero: true,
                placeholder: props.placeholder,

                onInput: (evt: { valueText: string , values: number[]}) => {
                    if (evt.values.length == requiredDigits) {
                        lastSelectedValue.value = evt.valueText;
                    } else { // Invalid value
                        lastSelectedValue.value = '';
                    }
                }
            });
        });

        const onConfirm = () => {
            context.emit('input', lastSelectedValue.value);
        }

        const onRequestHidePicker = () => {
            context.emit('hide-picker');
        }

        return {
            confirmEnabled,
            numpad,
            onConfirm,
            onRequestHidePicker
        }
    }
})
